import { LinearProgress, Stack, Typography } from '@mui/material'
import type { Fill } from './fill'

export function FillRate({ fill }: { fill: Fill }) {
  const percent = fill.required === 0 ? 0 : (100 * fill.accepted) / fill.required
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', width: 120, flexShrink: 0 }}>
      <LinearProgress
        variant="determinate"
        value={percent}
        color={percent >= 100 ? 'success' : 'primary'}
        aria-label="Bénévoles validés"
        sx={{ flex: 1 }}
      />
      <Typography variant="body2" color="text.secondary">
        {fill.accepted}/{fill.required}
      </Typography>
    </Stack>
  )
}
